export class AssetInfo {
  id: string;
  source7ProductId?: number;
  assetCopy: string;
  fetchExtendedInfo: boolean;
}
